import { Component, Input, AfterViewInit, OnInit} from "@angular/core";
import { FormGroup } from "@angular/forms";

import { InsaCronService } from "../../../../../insa-services";
import { EmailJobDetails } from "../../../../../insa-models";

@Component({
    selector: "edit-email-details",
    template: require("./edit-email-activity-details.component.html")
})

export class EditEmailActivityDetails implements OnInit{
    _activityID: any;
    @Input() editEmailForm: FormGroup;
    @Input() set emailDetails(emailDataActID: any) {
        this._activityID = emailDataActID;
    }

    // emailData: EmailJobDetails = new EmailJobDetails();  holi
    emailData: EmailJobDetails = new EmailJobDetails();

    constructor(private _insaChronosService: InsaCronService){  }

    ngOnInit(){
        // console.log(this._activityID);
        if(this._activityID !== undefined && this._activityID !== null){
            this._insaChronosService.getEmailDetailsById(this._activityID).subscribe((p: any) => this.emailData = p);
        }  
    }

    // ngAfterViewInit(){
    //     if(this._activityID !== undefined && this._activityID !== null ){
    //         this._insaChronosService.getEmailDetailsById(this._activityID).subscribe(p => this.emailData = p);
    //     }
    // }
}





// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-activities-detail/email-acitivity-details/edit-email-activity-details.component.ts